/* Technology explanations are shared with Swift Filter's verified facets. */
(function () {
  'use strict';
  if (window.__fcTechnologyGuide) return;
  window.__fcTechnologyGuide = true;
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fc-technology]');
    if (!trigger) return;
    var guide = (window.FCTechnologies || {})[trigger.dataset.fcTechnology];
    if (!guide) return;
    var section = trigger.closest('.fc-technologies');
    var lang = (section.dataset.fcLocale || '').indexOf('ar') === 0 ? 'ar' : 'en';
    var dialog = document.createElement('dialog');
    dialog.className = 'fc-tech-dialog';
    dialog.setAttribute('aria-labelledby', 'fc-tech-dialog-title');
    dialog.setAttribute('aria-describedby', 'fc-tech-dialog-description');
    dialog.innerHTML = '<button type="button" class="fc-tech-close">×</button>' +
      '<p class="fc-tech-eyebrow"></p><h2 id="fc-tech-dialog-title"></h2>' +
      '<div class="fc-tech-languages" role="group"><button type="button" lang="en" data-lang="en">English</button>' +
      '<button type="button" lang="ar" data-lang="ar">العربية</button></div>' +
      '<p id="fc-tech-dialog-description"></p><a class="fc-tech-browse"></a>';
    var title = dialog.querySelector('h2');
    title.textContent = guide.label;
    title.dir = 'ltr';
    var browse = dialog.querySelector('a');
    var url = new URL(section.dataset.fcCollectionUrl, window.location.origin);
    url.searchParams.set('sf_technologies', trigger.dataset.fcTechnology);
    browse.href = url.pathname + url.search;
    function translate() {
      var text = window.FCTechnologyUI[lang];
      dialog.dir = lang === 'ar' ? 'rtl' : 'ltr';
      dialog.lang = lang;
      dialog.querySelector('.fc-tech-close').setAttribute('aria-label', text.close);
      dialog.querySelector('.fc-tech-eyebrow').textContent = text.eyebrow;
      dialog.querySelector('#fc-tech-dialog-description').textContent = guide[lang];
      dialog.querySelector('.fc-tech-languages').setAttribute('aria-label', lang === 'ar' ? 'لغة الشرح' : 'Explanation language');
      dialog.querySelectorAll('[data-lang]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.lang === lang)); });
      browse.textContent = text.browse + ' ' + guide.label;
    }
    translate();
    var previousOverflow = document.body.style.overflow;
    dialog.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow;
      dialog.remove();
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    });
    dialog.querySelector('.fc-tech-close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelectorAll('[data-lang]').forEach(function (button) {
      button.addEventListener('click', function () { lang = button.dataset.lang; translate(); });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) dialog.close();
    });
    document.body.appendChild(dialog);
    document.body.style.overflow = 'hidden';
    dialog.showModal();
  });
})();
